import { render, staticRenderFns } from "./tag_identity.vue?vue&type=template&id=9a700d96&scoped=true"
import script from "./tag_identity.vue?vue&type=script&lang=js"
export * from "./tag_identity.vue?vue&type=script&lang=js"
import style0 from "./tag_identity.vue?vue&type=style&index=0&id=9a700d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a700d96",
  null
  
)

export default component.exports